{
  "buttons": {
    "accept": "Confirmer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "large": "Grand",
    "no": "Non",
    "normal": "Normal",
    "reject": "Annuler",
    "save": "Enregistrer",
    "small": "Petit",
    "yes": "Oui"
  },
  "confirm": {
    "default": {
      "header": "Confirmer",
      "message": "Voulez-vous continuer ?"
    },
    "delete": {
      "header": "Supprimer l'entrée",
      "message": "Voulez-vous vraiment supprimer cette entrée ?"
    },
    "save": {
      "header": "Enregistrer l'entrée",
      "message": "Voulez-vous vraiment enregistrer cette entrée ?"
    }
  },
  "enums": {
    "AD_SPACE": "Espace publicitaire",
    "ANCILLARY_AREA": "Surface annexe",
    "COMMERCIALCENTRE": "Centre commercial",
    "CONCESSION_AREA": "Zone de concession",
    "DE": "Allemand",
    "EN": "Anglais",
    "ENGLISH": "Anglais",
    "FR": "Français",
    "FRENCH": "Français",
    "GERMAN": "Allemand",
    "HU": "Hongrois",
    "HUNGARIAN": "Hongrois",
    "MAIN_AREA": "Surface principale",
    "OFFICEBUILDING": "Immeuble de bureaux",
    "OTHER": "Autre",
    "OUTLET": "Magasin d'usine",
    "PARKING_AREA": "Zone de stationnement",
    "PARTLY": "en cours",
    "PROCESSED": "classifié",
    "RETAILCENTER": "Centre de détail",
    "SALES": "Vente",
    "STANDALONE": "Indépendant",
    "STORAGE": "Stockage",
    "UNPROCESSED": "non traité"
  },
  "errors": {
    "CANNOT_BE_CREATED": "L'élément ne peut pas être créé",
    "CANNOT_BE_DELETED": "L'élément ne peut pas être supprimé",
    "CANNOT_BE_FOUND": "L'élément ne peut pas être trouvé",
    "CANNOT_BE_UPDATED": "L'élément ne peut pas être mis à jour"
  },
  "info": {
    "SUCCESS_CREATE": "L'élément a été créé avec succès",
    "SUCCESS_DELETE": "L'élément a été supprimé avec succès",
    "SUCCESS_UPDATE": "L'élément a été mis à jour avec succès"
  },
  "labels": {
    "accountingArea": "Zone comptable",
    "add": "Nouvelle entrée",
    "additionalAddressInfo": "Informations d'adresse supplémentaires",
    "address": "Adresse",
    "addressId": "ID de l'adresse",
    "addressIdShort": "IDA",
    "allIDs": "IDs Documents & Emails",
    "allIDsShort": "IDs",
    "allNamesAndSubjects": "Objet",
    "allocationSpace": "Espace d'allocation",
    "areaCount": "Nombre de zones",
    "areaNameExternal": "Nom externe de la zone",
    "areas": "Zones",
    "attachments": "Pièces jointes",
    "boardName": "Nom du conseil",
    "branchnumber": "Numéro de branche",
    "city": "Ville",
    "cityName": "Nom de la ville",
    "cityZip": "Code postal de la ville",
    "classificationStatus": "Statut",
    "columnName": "Nom de la colonne",
    "companies": "Entreprises",
    "company": "Entreprise",
    "companyCount": "Nombre d'entreprises",
    "companyCountShort": "Nb.",
    "companyName": "Nom de l'entreprise",
    "contactPerson": "Personne de contact",
    "contracts": "Contrats",
    "contradictionPackages": "Paquets de contradictions",
    "country": "Pays",
    "countryCode": "Code du pays",
    "countryName": "Nom du pays",
    "customer": "Client",
    "customerCode": "Code client",
    "customerCount": "Nombre de clients",
    "customerCountShort": "Nb.",
    "customerGroup": "Groupe de clients",
    "customergroupDescription": "Description",
    "customerGroupId": "ID du groupe de clients",
    "customergroupName": "Nom du groupe de clients",
    "customergroupNameShort": "Nom",
    "customerId": "ID du client",
    "customerIdShort": "Cl-ID",
    "customerName": "Nom du client",
    "deactivate": "Désactiver",
    "deadline": "Échéance",
    "deadlineOffset": "Délai",
    "deadlineOverdue": "Échéance dépassée",
    "deadlineRisk": "Risque d'échéance",
    "delete": "Supprimer",
    "deleteMany": "Supprimer {count} entrée | Supprimer {count} entrées",
    "description": "Description",
    "detailDescription": "Description détaillée",
    "documentId": "ID du document",
    "documentName": "Nom du document",
    "documents": "Documents",
    "edit": "Modifier",
    "email": "E-mail",
    "eMail": "E-mail",
    "emails": "E-mails",
    "endDate": "Date de fin",
    "extra": "Supplémentaire",
    "favAdd": "Enregistrer comme favori",
    "favRemove": "Supprimer des favoris",
    "firstName": "Prénom",
    "firstPossibleEndDate": "Première date de fin possible",
    "firstYear": "Première année",
    "germanFederalState": "État fédéral allemand",
    "houseNumber": "Numéro de maison",
    "id": "ID",
    "internal": "Interne",
    "isGroupAdmin": "Admin du groupe",
    "isInternal": "Interne",
    "languageOfCorrespondence": "Langue de correspondance",
    "lastName": "Nom de famille",
    "location": "Emplacement",
    "locationId": "ID de l'emplacement",
    "locationIdShort": "Loc-ID",
    "locationName": "Nom de l'emplacement",
    "locations": "Emplacements",
    "mainUsage": "Utilisation principale",
    "managerName": "Nom du gestionnaire",
    "modifiedAt": "Modifié le",
    "moveinTime": "Heure d'emménagement",
    "moveoutTime": "Heure de départ",
    "name": "Nom",
    "nameExternal": "Externe",
    "ownerName": "Nom du propriétaire",
    "partnephonerCount": "Nombre de groupes de partenaires",
    "partnephonerCountShort": "GPs",
    "partnercompany": "Entreprise partenaire",
    "partnerCount": "Nombre de partenaires",
    "partnerCountShort": "Nb.",
    "partnerGroupId": "ID du groupe de partenaires",
    "partnerGroupIdShort": "Gp-ID",
    "phone": "Téléphone",
    "pointOfSale_name": "Point de vente",
    "pointOfSales": "Point de vente",
    "pos": "POS",
    "posName": "Nom du point de vente",
    "postalCode": "Code postal",
    "postalCodeShort": "CP",
    "processAddStep": "Créer une nouvelle étape",
    "processAddStepConnect": "Créer une nouvelle étape et la lier",
    "processAssignedTeam": "Équipe assignée",
    "processAssignToNewStep": "Assigner à une nouvelle étape",
    "processConnectPlugin": "Lier un plugin UI",
    "processDownload": "Télécharger le JSON du processus",
    "processExternal": "Processus externe",
    "processFinishTask": "Terminer la tâche",
    "processGotoExternalStep": "Passer au processus externe",
    "processGotoStart": "Retour au début",
    "processIsExternalStep": "Est une étape de processus externe",
    "processIsUploaded": "Téléchargé :",
    "processLoadFromJSON": "Charger le processus",
    "processName": "Processus",
    "processNewOption": "Nouvelle option",
    "processOptionNextStepAssignTeam": "Assigner une équipe",
    "processOptionsNextStep": "Options pour les prochaines étapes",
    "processPasteJSON": "Coller le JSON",
    "processPreview": "Aperçu",
    "processRemoveOption": "Supprimer l'option",
    "processRemovePlugin": "Supprimer le plugin",
    "processStep": "Étape",
    "processStepDescription": "Description de l'étape",
    "processStepName": "Nom de l'étape",
    "processUploadJSON": "Télécharger le JSON",
    "propertyDescription": "Description",
    "receiptDate": "Date de réception",
    "rentalSpace": "Espace de location",
    "senderName": "Expéditeur",
    "serviceObjects": "Objets de service",
    "size": "Taille",
    "sizeShort": "T.",
    "spaceValue": "Valeur de l'espace",
    "startDate": "Date de début",
    "street": "Rue",
    "streetNumber": "Numéro de rue",
    "subject": "Objet",
    "sumAreaSpaces": "Somme des espaces de la zone",
    "tableSettingsFontsize": "Taille de la police",
    "tableSettingsFooterPagination": "Pagination dans le pied de page",
    "tableSettingsGrid": "Grille",
    "tableSettingsHdlBehaviour": "Comportement de la table",
    "tableSettingsHdlColumns": "Colonnes visibles",
    "tableSettingsHdlLayout": "Disposition de la table",
    "tableSettingsHdlSize": "Taille",
    "tableSettingsInstantEdit": "Édition instantanée",
    "tableSettingsMultiselect": "Cases à cocher multiples",
    "tableSettingsStripedRows": "Lignes alternées",
    "tags": "Étiquettes",
    "taxinvoices": "Factures TA",
    "tickets": "Tickets",
    "totalArea": "Surface totale",
    "totalAreaShort": "m²",
    "type": "Type",
    "typeName": "Nom du type",
    "typeOfUse": "Type d'utilisation",
    "unitName": "Nom de l'unité",
    "usageType": "Type d'utilisation",
    "usageTypeAllocationspaceValue": "Valeur de l'espace d'allocation",
    "usageTypeMainUsage": "Utilisation principale",
    "usagetypeName": "Nom du type d'utilisation",
    "usageTypeRentalspaceValue": "Valeur de l'espace de location",
    "usageTypeValidFrom": "Valide à partir de",
    "usageTypeValidTo": "Valide jusqu'à",
    "users": "Utilisateurs",
    "validFrom": "Valide à partir de",
    "validTo": "Valide jusqu'à",
    "vat": "TVA",
    "version": "Version",
    "versionAddress": "Version de l'adresse",
    "versionAddressShort": "VA",
    "versionShort": "V.",
    "view": "Voir",
    "zip": "Code postal"
  },
  "messages": {
    "noTableData": "Aucune donnée disponible",
    "noTableFilterData": "Aucun résultat pour ce filtre"
  },
  "navigation": {
    "access": "Accès",
    "accountDataRelated": "Données liées au compte",
    "address": "Adresse",
    "administration": "Administration",
    "areas": "Zones",
    "areaTypes": "Types de zones",
    "attributeTranslations": "Traductions des attributs",
    "authorizations": "Autorisations",
    "choices": "Choix",
    "cities": "Villes",
    "claimTypes": "Types de réclamations",
    "classificationOfDocumentEntries": "Entrée",
    "companies": "Entreprises",
    "company": "Seybold interne",
    "companyDatabase": "Clients",
    "conditionList": "Liste des conditions",
    "configInvoiceAndContradictionRelatedData": "Configurer les données liées aux factures et contradictions",
    "configuration": "Configuration",
    "contactPerson": "Personne de contact",
    "contactsCustomers": "Contacts",
    "contactsInternal": "Contacts",
    "contactsPartners": "Contacts",
    "contractCriteriaTypes": "Types de critères de contrat",
    "contractDataRelated": "Données liées au contrat",
    "contracts": "Contrats",
    "contractsTermsAndConditions": "Contrats - Termes et conditions",
    "contractTitles": "Titres de contrat",
    "contractTypes": "Types de contrat",
    "contradictionPackages": "Paquets de contradictions",
    "costTypes": "Types de coûts",
    "countries": "Pays",
    "criteriaAndChoices": "Critères et choix",
    "crud": "CRUD",
    "currencies": "Devises",
    "customerCount": "Les clients comptent",
    "customergroups": "Groupes",
    "customers": "Clients",
    "dashboard": "Tableau de bord",
    "dashboardOfBoards": "Tableau de bord des tableaux",
    "dashboardTickets": "Tableau de bord des tickets",
    "deadlineList": "Liste des échéances",
    "documentContractType": "Type de contrat de document",
    "documentTypes": "Types de documents",
    "facilityServices": "Services d'installation",
    "favorites": "Favoris",
    "functions": "Fonctions",
    "geography": "Lieux",
    "importContract": "Importer un contrat",
    "importFunction": "Importer une fonction",
    "importStandard": "Importer une norme",
    "inbox": "Boîte de réception",
    "indexClauses": "Clauses d'indice",
    "inspectionResults": "Résultats d'inspection",
    "invoiceAndContradictionData": "Données de facturation et de contradiction",
    "invoiceCriteria": "Critères de facturation",
    "invoiceValueTypes": "Types de valeurs de factures",
    "kanbanTickets": "Tickets Kanban",
    "kanbanTicketsConfiguration": "Tickets Kanban",
    "languages": "Langues",
    "listOfTicketsAndTasks": "Liste des tickets et des tâches",
    "locations": "Sites",
    "locationTypes": "Types de lieux",
    "logout": "Déconnexion",
    "main": "Principal",
    "masterdata": "Données de base",
    "maturityTypes": "Types d'échéance",
    "menu": "Menu",
    "miscellaneous": "Divers",
    "myTasksAndTickets": "Mes tâches et tickets",
    "myTasksAndTicketsConfiguration": "Mes tâches et tickets",
    "newBusiness": "Nouvelle affaire",
    "objectDataRelated": "Données liées à l'objet",
    "operations": "Opérations",
    "partnerCompanies": "Entreprises partenaires",
    "partnercompanyDatabase": "Partenaires",
    "partnergroups": "Groupes",
    "partners": "Partenaires",
    "partnerTypes": "Types de partenaires",
    "payments": "Paiements",
    "pointofsales": "Points de vente",
    "pointOfSales": "Points de vente",
    "processes": "Processus",
    "products": "Produits",
    "rating": "Évaluation",
    "recurringPayment": "Paiement récurrent",
    "recurringPaymentTypes": "Types de paiement récurrent",
    "rentalsAndContracts": "Documents",
    "resultCategories": "Catégories de résultats",
    "rights": "Droits",
    "salutions": "Salutations",
    "savingTypes": "Types d'économies",
    "serviceObjects": "Objets de service",
    "serviceObjectTypes": "Types d'objets de service",
    "tableGroups": "Groupes de tableaux",
    "tables": "Tableaux",
    "tags": "Étiquettes",
    "tapsInvoicePositions": "Positions de facture TAP",
    "taxinvoices": "TA - Factures",
    "teams": "Équipes",
    "textModules": "Modules de texte",
    "textTemplates": "Modèles de texte",
    "textTemplateVariables": "Variables de modèles de texte",
    "ticketListIssue": "Problème de liste de tickets",
    "ticketPriorities": "Priorités des tickets",
    "tickets": "Tickets",
    "ticketTypes": "Types de tickets",
    "trackRecord": "Palmarès",
    "translations": "Traductions",
    "units": "Unités",
    "usageTypes": "Types d'utilisation",
    "userAdministration": "Administration des utilisateurs",
    "userProfile": "Profil",
    "users": "Utilisateurs",
    "userTypes": "Types d'utilisateurs"
  },
  "pages": {
    "404": {
      "back2Home": "Retour à la maison",
      "headline": "Cette page n'existe pas",
      "opener": "Vérifiez le chemin dans votre URL",
      "title": "Page non trouvée"
    },
    "access": {
      "title": "Accès"
    },
    "address": {
      "title": "Adresse"
    },
    "areas": {
      "title": "Zones"
    },
    "areasDetail": {
      "title": "Détails de la zone"
    },
    "areasDetailEdit": {
      "title": "Modifier la zone"
    },
    "areasNew": {
      "title": "Nouvelle zone"
    },
    "areaTypes": {
      "title": "Types de zones"
    },
    "attributeTranslations": {
      "title": "Traductions des attributs"
    },
    "authorizations": {
      "title": "Autorisations"
    },
    "choices": {
      "title": "Choix"
    },
    "cities": {
      "title": "Villes"
    },
    "claimTypes": {
      "title": "Types de réclamations"
    },
    "classification": {
      "actions": "Actions",
      "inbox": "Boîte de réception",
      "message": "Message",
      "selectMessage": "Sélectionnez un élément pour en voir les détails.",
      "title": "Classification des Entrées de Documents"
    },
    "classificationOfDocumentEntries": {
      "title": "Classification des entrées de documents"
    },
    "classificationOfDocumentEntriesV2": {
      "title": "Classification des entrées de documents V2"
    },
    "companies": {
      "title": "Entreprises"
    },
    "conditionList": {
      "title": "Liste des conditions"
    },
    "configurationKanbanTickets": {
      "title": "Configuration des tickets Kanban"
    },
    "contactPerson": {
      "title": "Personne de contact"
    },
    "contractCriteriaTypes": {
      "title": "Types de critères de contrat"
    },
    "contracts": {
      "title": "Contrats"
    },
    "contractTitles": {
      "title": "Titres de contrat"
    },
    "contractTypes": {
      "title": "Types de contrat"
    },
    "contradictionPackages": {
      "title": "Paquets de contradictions"
    },
    "costTypes": {
      "title": "Types de coûts"
    },
    "countries": {
      "title": "Pays"
    },
    "criteriaAndChoices": {
      "title": "Critères et choix"
    },
    "crud": {
      "title": "CRUD"
    },
    "currencies": {
      "title": "Devises"
    },
    "customergroups": {
      "title": "Groupes de clients"
    },
    "customergroupsDetail": {
      "title": "Détails du groupe de clients"
    },
    "customergroupsDetailEdit": {
      "title": "Modifier le groupe de clients"
    },
    "customergroupsNew": {
      "title": "Nouveau groupe de clients"
    },
    "customers": {
      "title": "Clients"
    },
    "customersDetail": {
      "title": "Détails du client"
    },
    "customersDetailEdit": {
      "title": "Modifier le client"
    },
    "customersNew": {
      "title": "Nouveau client"
    },
    "dashboardBoard": {
      "title": "Tableau de bord"
    },
    "dashboardTicket": {
      "title": "Ticket du tableau de bord"
    },
    "deadlineList": {
      "title": "Liste des échéances"
    },
    "documentContractType": {
      "title": "Type de contrat de document"
    },
    "documentTypes": {
      "title": "Types de documents"
    },
    "facilityServiceObjects": {
      "title": "Objets de service des installations"
    },
    "functions": {
      "title": "Fonctions"
    },
    "home": {
      "title": "Accueil"
    },
    "importContract": {
      "title": "Importer un contrat"
    },
    "importStandard": {
      "title": "Importer une norme"
    },
    "indexClauses": {
      "title": "Clauses d'indice"
    },
    "inspectionResults": {
      "title": "Résultats de l'inspection"
    },
    "invoiceCriteria": {
      "title": "Critères de facturation"
    },
    "invoiceValueTypes": {
      "title": "Types de valeurs de factures"
    },
    "languages": {
      "title": "Langues"
    },
    "listOfTickets": {
      "title": "Liste des tickets"
    },
    "locations": {
      "title": "Emplacements"
    },
    "locationTypes": {
      "title": "Types de lieux"
    },
    "mainKanbanTickets": {
      "title": "Tickets Kanban"
    },
    "mainKanbanTicketsKanbanview": {
      "subtitle": "Tâches dans le tableau"
    },
    "mainKanbanTicketsView": {
      "subtitle": "Configuration",
      "title": "Tableau Kanban"
    },
    "maturityTypes": {
      "title": "Types d'échéance"
    },
    "menu": {
      "title": "Menu"
    },
    "myTasksAndTickets": {
      "title": "Mes tâches et tickets"
    },
    "newBusiness": {
      "title": "Nouvelle affaire"
    },
    "partnerCompanies": {
      "title": "Entreprises partenaires"
    },
    "partnergroups": {
      "title": "Groupes de partenaires"
    },
    "partnergroupsDetail": {
      "title": "Détails du groupe de partenaires"
    },
    "partnergroupsDetailEdit": {
      "title": "Modifier le groupe de partenaires"
    },
    "partnergroupsNew": {
      "title": "Nouveau groupe de partenaires"
    },
    "partners": {
      "title": "Partenaires"
    },
    "partnersDetail": {
      "title": "Détails du partenaire"
    },
    "partnersDetailEdit": {
      "title": "Modifier le partenaire"
    },
    "partnersNew": {
      "title": "Nouveau partenaire"
    },
    "partnerTypes": {
      "title": "Types de partenaires"
    },
    "payments": {
      "title": "Paiements"
    },
    "pointofsales": {
      "title": "Point de vente principal"
    },
    "pointOfSales": {
      "title": "Points de vente"
    },
    "pointofsalesDetail": {
      "title": "Détail du point de vente"
    },
    "pointofsalesDetailEdit": {
      "title": "Modifier le point de vente"
    },
    "pointofsalesNew": {
      "title": "Nouveau point de vente"
    },
    "processes": {
      "title": "Modélisation des rocesspus"
    },
    "products": {
      "title": "Produits"
    },
    "rating": {
      "title": "Évaluation"
    },
    "recurringPayment": {
      "title": "Paiement récurrent"
    },
    "recurringPaymentTypes": {
      "title": "Types de paiement récurrent"
    },
    "resultCategories": {
      "title": "Catégories de résultats"
    },
    "salutions": {
      "title": "Salutations"
    },
    "savingTypes": {
      "title": "Types d'économies"
    },
    "serviceObjects": {
      "title": "Objets de service"
    },
    "serviceObjectTypes": {
      "title": "Types d'objets de service"
    },
    "tableGroups": {
      "title": "Groupes de tableaux"
    },
    "tables": {
      "title": "Tableaux"
    },
    "tags": {
      "title": "Étiquettes"
    },
    "tapsInvoicePositions": {
      "title": "Positions de factures TAP"
    },
    "taxinvoices": {
      "title": "Factures TA"
    },
    "teams": {
      "title": "Équipes"
    },
    "textModules": {
      "title": "Modules de texte"
    },
    "textTemplates": {
      "title": "Modèles de texte"
    },
    "textTemplateVariables": {
      "title": "Variables de modèles de texte"
    },
    "ticketListIssue": {
      "title": "Problème de liste de tickets"
    },
    "ticketPriorities": {
      "title": "Priorités des tickets"
    },
    "ticketTypes": {
      "title": "Types de tickets (Bientôt disponible)"
    },
    "trackRecord": {
      "title": "Palmarès"
    },
    "translations": {
      "title": "Traductions"
    },
    "undefined": {
      "title": "Page inconnue"
    },
    "units": {
      "title": "Unités"
    },
    "unknownPage": {
      "title": "Page inconnue"
    },
    "usageTypes": {
      "title": "Types d'utilisation"
    },
    "users": {
      "title": "Utilisateurs"
    },
    "userTypes": {
      "title": "Types d'utilisateurs"
    }
  },
  "placeholder": {
    "actingBy": "Représenté par",
    "areaType": "Type de zone",
    "areaTypeOfUse": "Type d'utilisation",
    "columns": "Colonnes visibles",
    "contractActionType": "Type d'action contractuelle",
    "customerGroupId": "Groupe de clients assigné",
    "customerId": "Sélectionnez un client",
    "extensionUnit": "Unité d'extension",
    "languageOfCorrespondence": "Langue de correspondance préférée",
    "locationId": "Sélectionnez un lieu",
    "locationType": "Type de lieu",
    "noticePeriodUnit": "Unité de préavis",
    "partnerGroupId": "Groupe de partenaires assigné",
    "processDescription": "Décrivez brièvement l'objectif de ce processus.",
    "processName": "Nom unique du processus",
    "processOptionNextStep": "Lier une étape",
    "processOptionNextStepAssignTeam": "Attribuer automatiquement à une équipe",
    "processStepDescription": "Quel est l'objectif de cette étape ? Que peut réaliser ou décider l'utilisateur ici ?",
    "processStepName": "Nom unique de l'étape",
    "processUiPlugin": "Lier un plugin UI",
    "quickfilter": "Filtre rapide",
    "salutation": "Salutation",
    "title": "Titre"
  },
  "primevue": {
    "clear": "Effacer",
    "dayNames": [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi"
    ],
    "dayNamesMin": [
      "D",
      "L",
      "M",
      "M",
      "J",
      "V",
      "S"
    ],
    "dayNamesShort": [
      "Dim",
      "Lun",
      "Mar",
      "Mer",
      "Jeu",
      "Ven",
      "Sam"
    ],
    "firstDayOfWeek": 1,
    "monthNames": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    "monthNamesShort": [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Juin",
      "Juil",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc"
    ],
    "today": "Aujourd`hui"
  },
  "titletags": {
    "addLang": "Ajouter une traduction pour « {locale} »",
    "booleanFalse": "Non",
    "booleanTrue": "Oui",
    "collapse": "Réduire le texte",
    "expand": "Afficher tout le texte",
    "isDraftFalse": "C'est en production",
    "isDraftTrue": "C'est un brouillon",
    "showTableSettings": "Configuration de la table",
    "toggleSplitviewOff": "Vue partagée",
    "toggleSplitviewOn": "Vue complète"
  },
  "toast": {
    "create": {
      "detail": "L'entrée a été créée"
    },
    "default": {
      "detail": "La requête a été exécutée",
      "summary": "Terminé"
    },
    "delete": {
      "detail": "L'entrée a été supprimée"
    },
    "error": "Erreur",
    "errors": {
      "CANNOT_BE_CREATED": "L'élément ne peut pas être créé",
      "CANNOT_BE_DELETED": "L'élément ne peut pas être supprimé",
      "CANNOT_BE_FOUND": "L'élément est introuvable",
      "CANNOT_BE_UPDATED": "L'élément ne peut pas être mis à jour",
      "Internal server error": "Une erreur interne du serveur s'est produite"
    },
    "update": {
      "detail": "L'entrée a été mise à jour"
    }
  }
}
